module.exports = __webpack_public_path__ + "static/media/Raikou_gaussian2.05529b16.png";